import type { MaybeRef } from "vue"
import type { ServerResponse } from "@/http"
import type { IUserInvitationResponse } from "@/models"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { axios } from "@/axios"
import { UserInvitation } from "@/models"

/**
 * Fetches the user invitation details for a specific event using the provided token.
 */
export async function getCoHostInvitation(eventVaultId?: number, token?: string) {
  if (!eventVaultId) {
    throw new Error(
      "Missing `eventVaultId` when attempting to get user invitation. Please ensure `eventVaultId` is provided.",
    )
  }

  if (!token) {
    throw new Error(
      "Missing `token` when attempting to get user invitation. Please ensure `token` is provided.",
    )
  }

  const response = await axios.get<ServerResponse<IUserInvitationResponse>>(`api/${eventVaultId}/invitation/${token}`)

  return UserInvitation.fromResponse(response.data.Data)
}

const GET_CO_HOST_INVITATION_KEY = "getCoHostInvitation"

export function useGetCoHostInvitation(eventVaultId?: MaybeRef<number | undefined>, token?: MaybeRef<string | undefined>) {
  return useQuery({
    queryKey: [GET_CO_HOST_INVITATION_KEY, eventVaultId, token],
    queryFn: () => getCoHostInvitation(toValue(eventVaultId), toValue(token)),
    enabled: Boolean(toValue(eventVaultId)) && Boolean(toValue(token)),
  })
}
